import UploadImageFormFields from '@Containers/UploadImageFormFields';
import { Box } from '@mui/material';
import { BusinessValueChainFormValues } from '../ImpactsOnStakeholdersFormProvider/types';
import { useWatch } from 'react-hook-form';

const BusinessValueChainUploadImage = () => {
  const { completedSection } =
    useWatch({
      name: 'businessValueChain',
    }) ?? ({} as BusinessValueChainFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <Box mt={2}>
      <UploadImageFormFields
        title={'รูปภาพห่วงโซ่คุณค่าธุรกิจ'}
        name={`businessValueChain`}
        disabledTh={isCompletedTh}
        disabledEn={isCompletedEn}
      />
    </Box>
  );
};

export default BusinessValueChainUploadImage;
